module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"disclaimer":"getnext acts as marketplace between buyers and the artists. All purchases are concluded directly between these parties.","whatis":"What is getnext?","imprint":"Imprint"},"de":{"disclaimer":"getnext (Fans & Fortune GmbH) dient nur als Vermittlerin. Der Vertrag wird zwischen Käufer*in und Künstler*in geschlossen!","whatis":"Was ist getnext?","imprint":"Impressum"}}')
  delete Component.options._Ctor
}
